import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth.guard';
import { PagenotfoundComponent } from './shared/pagenotfound/pagenotfound.component';
import { LoginAccessComponent } from './login/login-access/login-access.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'cibilstats',
        loadChildren: './cibil/cibil.module#CibilModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'wishfinconstant',
        loadChildren: './wishfin-constant/wishfin-constant.module#WishfinConstantModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'fixeddeposit',
        loadChildren: './fixeddeposit/fixeddeposit.module#FixeddepositModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'pagesetting',
        loadChildren: './setting/setting.module#SettingModule',
        canActivate: [AuthGuard]
      },      
      {
        path: 'menusetting',
        loadChildren: './setting/setting.module#SettingModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'ftbannerstats',
        loadChildren: './ft-stats/ft-stats.module#FtStatsModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'rate',
        loadChildren: './rate/rate.module#RateModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'errorlog',
        loadChildren: './errorlog/errorlog.module#ErrorlogModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'career',
        loadChildren: './career/career.module#CareerModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'cibilreferral',
        loadChildren: './cibilreferral/cibilreferral.module#CibilreferralModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'mis',
        loadChildren: './mis/mis.module#MISModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'banksurl',
        loadChildren: './banks/banks.module#BanksModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'cache',
        loadChildren: './cache/cache.module#CacheModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'user',
        loadChildren: './user/user.module#UserModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'investmfonline',
        loadChildren: './investmfonline/investmfonline.module#InvestmfonlineModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'notification',
        loadChildren: './notification/notification.module#NotificationModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'not-found',
        component: PagenotfoundComponent,
        canActivate: [AuthGuard]
      }      
    ]
  },
  {
    path: 'login',
    component: LoginAccessComponent
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
